function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7426 4C7.01878 4 4 7.01878 4 10.7426V21.2574C4 24.9812 7.01878 28 10.7426 28H21.2574C24.9812 28 28 24.9812 28 21.2574V10.7426C28 7.01878 24.9812 4 21.2574 4H10.7426ZM10.6484 6.21618C8.20056 6.21618 6.21618 8.20056 6.21618 10.6484V21.3517C6.21618 23.7996 8.20056 25.784 10.6484 25.784H21.3046C23.7524 25.784 25.7368 23.7996 25.7368 21.3517V10.6484C25.7368 8.20056 23.7524 6.21618 21.3046 6.21618H10.6484Z",
  fill: "#959698"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9989 22.2003C19.3973 22.2003 22.1522 19.4454 22.1522 16.047C22.1522 12.6487 19.3973 9.8938 15.9989 9.8938C12.6006 9.8938 9.8457 12.6487 9.8457 16.047C9.8457 19.4454 12.6006 22.2003 15.9989 22.2003ZM15.9989 20.0315C18.2254 20.0315 20.0303 18.2266 20.0303 16.0001C20.0303 13.7736 18.2254 11.9686 15.9989 11.9686C13.7724 11.9686 11.9674 13.7736 11.9674 16.0001C11.9674 18.2266 13.7724 20.0315 15.9989 20.0315Z",
  fill: "#959698"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.4596,
  cy: 9.58753,
  r: 1.43811,
  fill: "#959698"
});

function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.92ad2685.svg";
export { ForwardRef as ReactComponent };